
import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import SendIcon from '../../../assets/icons/send-icon';
import { AppState } from '../../../store';
import { setIsDownloadButtonDisabled } from '../../../store/configure/actions';
import { setModalOpen, setModalClosed } from '../../../store/modal/actions';
import { QueueFirmwareRequest } from '../../../entities/remote-flash-v1/models';
import { queueSoftwareRemoteFlashAction } from '../../../store/configure/remote-flash/actions';
import { firmwareProceedConfirmationMessage } from '../messages';
import useStyles from './styles';

const DownloadFile: FC<any> = (properties: {
    row: {
        original: {
            id: string;
            fileTypeId: string;
            partNumber: string;
            fileName: string | null;
        };
    },
}) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const { client } = useSelector((state: AppState) => state.login);
    const selectedEntity = useSelector((state: AppState) => state.search.selectedEntity);
    const softwareStatus = useSelector((state: AppState) => state.firmware.firmwareStatus);
    const { isDownloadButtonDisabled } = useSelector((state: AppState) => state.configSoftware);

    const clientAuth: any = client?.authenticate();
    const {
        metadata: { catloginid },
    } = clientAuth;


    const deviceKey = selectedEntity?.deviceKey;
    const deviceId = selectedEntity?.deviceId;

    const {
        row: {
            original: { id, fileTypeId, fileName, partNumber },
        },
    } = properties;

    const queueDeviceSoftware = (sha: string) => {
        if (deviceKey && softwareStatus) {
            const deviceDataForQueue: QueueFirmwareRequest = {
                devices: [
                    {
                        deviceKey: softwareStatus.deviceKey ? softwareStatus.deviceKey : deviceKey,
                        tags: ['deploymentfile'],
                    },
                    {
                        deviceId: deviceId || '',
                        tags: ['deploymentfile'],
                    },
                ],
                hash: sha,
                userId: catloginid,
                applicationId: softwareStatus?.lastUpdatedBySystem,
                transactionId: softwareStatus?.transactionId,
                partNumber,
            };
            dispatch(queueSoftwareRemoteFlashAction(deviceDataForQueue));
        }
        dispatch(setIsDownloadButtonDisabled(true));
    };

    const handleClickOpen = () => {
        dispatch(
            setModalOpen({
                open: true,
                message: firmwareProceedConfirmationMessage,
                accept: () => queueDeviceSoftware(id),
                cancel: () => { },
            }),
        );
    };

    return (
        <Box display="flex" justifyContent="flex-end">
            <Button
                className={classes.root}
                id={`send-to-device-${id}`}
                onClick={handleClickOpen}
                variant="outlined"
                size="small"
                disabled={isDownloadButtonDisabled}
                endIcon={<SendIcon />}
            >
                <Typography variant="button">send to device</Typography>
            </Button>
        </Box>
    );
};

export default DownloadFile;